import { apiSlice } from "./apiSlice";
import { CUSTOMERS_URL } from "../constants";

const customersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/createCustomer`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getCustomers: builder.query({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/getCustomers?${data.query ? data.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/updateCustomerDetails`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useUpdateCustomerMutation,
  useCreateCustomerMutation,
} = customersApiSlice;
